import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SchedulesReminderPageRoutingModule } from './schedules-reminder-routing.module';

import { SchedulesReminderPage } from './schedules-reminder.page';
import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SchedulesReminderPageRoutingModule
  ],
  declarations: [SchedulesReminderPage]
})
export class SchedulesReminderPageModule {}
